/*
 *
 * File: TermsOfUseScreen.jsx
 *
 * Purpose: Customer information sreen for the user.
 *
 * Autor:   Thomas Burgard (Software development)
 * Created: 10.04.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";

/**
 * Implementation of choose offer component.
 *
 * @returns JSX-HTML-DOM
 */
const TermsOfUseScreen = (props) => {
  const userData = props.userData;
  const { t, i18n } = useTranslation("common");

  //*************************************************************/
  //* Returns JSX code                                          */
  //*************************************************************/
  return (
    <>
      {/* Insert header component */}
      <Header userData={userData} />
      <div
        className="grid p-fluid"
        style={{ paddingLeft: "20px", paddingRight: "20px", marginTop: "30px" }}
      >         
        <div className="col-12 md:col-12">
          <div>Inhalt für AGB kommt bald!</div>
        </div>
      </div>
      <Footer userData={userData} />
    </>
  );
};

export default TermsOfUseScreen;
